<template>
  <div>
    <div v-if="users.length <= 0" class="text-center">
      <img src="assets/svg/comment.svg" :width="200" class="mg-b-5" />
      <div class="blue-grey--text font-weight-light text-lowercase">
        хоосон байна.
      </div>
    </div>
    <div v-else class="pd-y-10">
      <a
        v-if="allCount > users.length"
        @click="loadMore"
        role="button"
        class="tx-brand-01"
      >
        <feather type="arrow-up"></feather>Ачааллах
      </a>
      <div v-for="(t, i) in users" :key="i" class="mg-t-10">
        <div class="media" v-if="t.user != null">
          <div class="avatar">
            <img :src="t.user.avator" class="rounded-circle" alt />
          </div>
          <div class="media-body mg-l-15">
            <h6 class="tx-13 mg-b-2">{{ t.user.fullName }}</h6>
            <div class="progress ht-4 op-7 mg-b-5" v-if="t.perc > 0">
              <div
                class="progress-bar wd-85p"
                role="progressbar"
                aria-valuenow="85"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <div class="d-flex justify-content-between tx-13">
              <span class="tx-color-02">
                <span
                  @click="$emit('on-attach', t.attachmentId)"
                  v-if="t.attachmentId != null"
                  class="tx-brand-01"
                  role="button"
                >
                  <feather class="wd-16 ht-16" type="paperclip"></feather>файл
                </span>
                {{ t.execution }}
              </span>
            </div>
            <div>
              <small class="tx-medium text-muted">{{
                t.date | moment("YYYY.MM.DD HH:mm, dddd")
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getExecutionSkipLog, getExecutionById } from "@/api/taskInUser";
var _ = require("lodash");

export default {
  name: "forumTopicDetail",
  props: {
    taskId: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      allCount: 0,
      users: [],
      headData: {
        taskId: 0,
        //skip: initFlag == 2 ? 0 : this.logExecutions.length,
        skip: 0,
        //size: initFlag == 0 ? this.prop.firstSize : initFlag == 1 ? this.prop.size : 1
        size: 10
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    loadMore() {
      this.headData.skip = this.users.length;
      this.init();
    },
    init() {
      this.headData.taskId = this.taskId;
      getExecutionSkipLog({ params: this.headData, store: this.$store }).then(
        res => {
          if (res != false) {
            //console.log(res.data.count);
            this.allCount = res.data.count;
            //this.users= res.data.users;
            //this.users.splice(0,0, res.data.users);

            //this.users.unshift(_.orderBy(res.data.users, "id", "desc"));

            _.orderBy(res.data.users, "id", "desc").forEach(e => {
              this.users.unshift(e);
            });

            //console.log(this.users);
            //this.$emit('on-count', res.data.count);
            this.$emit(
              "on-reach-bottom",
              this.headData.skip == 0 ? "bottom" : "top"
            );
          }
        }
      );
    },
    initById(e) {
      getExecutionById({
        params: { taskId: e.taskId, commentId: e.id },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.users = this.users.concat(res.data.users);
          //this.$emit('on-count', res.data.count);
          this.$emit("on-reach-bottom", "bottom");
        }
      });
    }
  },
  computed: {
    tskId() {
      return this.taskId;
    }
  },
  watch: {
    tskId(val) {
      if (val > 0) {
        this.init();
      }
    }
  }
};
</script>
